/* Global styles - Design System is imported in App.tsx */

/* Material Symbols font */
@font-face {
  font-family: 'Material Symbols Outlined';
  font-style: normal;
  font-weight: 400;
  src: url(https://fonts.gstatic.com/s/materialsymbolsoutlined/v221/kJEhBvYX7BgnkSrU3T8UNK2aN1eYkzFzTjdMmmtt77VNKRs.woff2) format('woff2');
}

/* Manrope font for headlines */
@font-face {
  font-family: 'Manrope';
  font-style: normal;
  font-weight: 400 800;
  src: url(https://fonts.gstatic.com/s/manrope/v14/xn7dYHENgBkl7sA30OsiCA.woff2) format('woff2');
}

/* Inter font for body */
@font-face {
  font-family: 'Inter';
  font-style: normal;
  font-weight: 100 900;
  src: url(https://fonts.gstatic.com/s/inter/v19/UcC73FwrK3iLTeHuS_nVMrMxCp50SjIw2boKoduKmMEVuLyfAZ9hjp-Ek-_EeA.woff2) format('woff2');
}

/* Prevent overscroll bounce on iOS */
html, body, #root {
  height: 100%;
  overscroll-behavior: none;
}

/* Touch action optimization */
* {
  touch-action: manipulation;
}

/* Custom scrollbar hide */
::-webkit-scrollbar {
  display: none;
}
* {
  -ms-overflow-style: none;
  scrollbar-width: none;
}

/* Selection colors */
::selection {
  background-color: #0057bf33;
}

/* Focus visible for accessibility */
*:focus-visible {
  outline: 2px solid #0057bf;
  outline-offset: 2px;
}

/* Reduced motion */
@media (prefers-reduced-motion: reduce) {
  *, *::before, *::after {
    animation-duration: 0.01ms !important;
    animation-iteration-count: 1 !important;
    transition-duration: 0.01ms !important;
  }
}